import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
}));

function LandingPage() {
  const buildTimestamp = process.env.REACT_APP_BUILD_TIME || 'Unknown';
  
  return (
    <StyledBox>
      <Container maxWidth="md">
        <Typography 
          variant="h1" 
          component="h1" 
          align="center"
          sx={{ 
            fontSize: { xs: '3rem', md: '5rem' },
            fontWeight: 700,
            mb: 2,
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
          }}
        >
          Spectacled Giraffe
        </Typography>
        <Typography 
          variant="h3" 
          component="h2" 
          align="center"
          sx={{ 
            fontSize: { xs: '1.5rem', md: '2.5rem' },
            fontWeight: 300,
            opacity: 0.9
          }}
        >
          Coming Soon
        </Typography>
        <Typography 
          variant="caption" 
          align="center"
          sx={{ 
            display: 'block',
            mt: 4,
            opacity: 0.6,
            fontSize: '0.875rem'
          }}
        >
          Build: {buildTimestamp !== 'Unknown' ? new Date(buildTimestamp).toLocaleString() : buildTimestamp}
        </Typography>
      </Container>
    </StyledBox>
  );
}

export default LandingPage;
